import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import Gamification, { AchievementBadge, AchievementCard, PointSummary } from '../services/Gamification';
import RewardsHeader from '../components/RewardsHeader/RewardsHeader';
import AchievementActivityFeed from '../components/AchievementActivityFeed';
import AchievementCardList from '../components/AchievementCardList';
import AchievementBadgeList from '../components/AchievementBadgeList';

const Heading = styled.h1(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    font-weight: ${type.weight.black};
    font-family: ${type.face};
    color: ${color.grayscale[0]};
    text-transform: uppercase;
    text-align: center;
    margin: 0 0 35px 0;
  `;
});

const RewardsContainer = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    display: grid;
    grid-template-columns: 1fr 30%;
    border-radius: 16px;
    background-color: ${color.grayscale[1000]};
    padding: 17px 40px 17px 30px;
    box-shadow: ${shadow.regular};
    grid-column-gap: 20px;
  `;
});

const HeaderContainer = styled.div`
  grid-column: 1;
  grid-row: 1;
`;

const AchievementCardContainer = styled.div`
  grid-column: 1;
  grid-row: 3;
`;

const ActivityFeedContainer = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    position: relative;
    grid-column: 2;
    grid-row: 1 / span 3;
    padding-left: 8px;
    background-color: ${color.grayscale[1000]};

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      display: block;
      height: 100%;
      width: 1px;
      background-color: #dfdfdf;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    }

    &::after {
      position: absolute;
      top: 0;
      left: 1px;
      height: calc(100% + 5px);
      width: 7px;
      content: '';
      display: block;
      background-color: ${color.grayscale[1000]};
    }
  `;
});

const PlayerRewards: FC = () => {
  const [levelInfo, setLevelInfo] = useState<PointSummary>({
    title: '',
    progress: 0,
    points: 0,
    threshold: 0,
    level: -1,
  });

  const [achievementInfo, setAchievementInfo] = useState<AchievementCard[]>([]);
  // const [activityInfo, setActivityInfo] = useState<Activity[]>([]);
  const [unlockedAchievementInfo, setUnlockedAchievementInfo] = useState<AchievementBadge[]>([]);

  const getLevelSummary = async () => {
    const response = await Gamification.getPointSummary();

    if (response !== null) setLevelInfo(response);
  };

  const getAchievementInfo = async () => {
    const progress = await Gamification.getAchievementProgress();
    setAchievementInfo(progress);
  };

  const getUnlockedAchievements = async () => {
    const unlockedAchievementsResponse = await Gamification.getUnlockedAchievements(0);
    setUnlockedAchievementInfo(unlockedAchievementsResponse);
  };

  useEffect(() => {
    getLevelSummary();

    getAchievementInfo();
    getUnlockedAchievements();
  }, []);

  return (
    <>
      <div>
        <Heading>My Rewards</Heading>

        <RewardsContainer>
          <HeaderContainer>
            <RewardsHeader {...levelInfo} />
          </HeaderContainer>

          <AchievementBadgeList badges={unlockedAchievementInfo} />

          <AchievementCardContainer>
            {achievementInfo?.length > 0 && (
              <AchievementCardList achievements={achievementInfo} displayCount={3} spaced={true} />
            )}
          </AchievementCardContainer>

          <ActivityFeedContainer>
            <AchievementActivityFeed />
          </ActivityFeedContainer>
        </RewardsContainer>
      </div>
    </>
  );
};

export default PlayerRewards;
